import { assign, pick } from 'lodash';
import renderQueryString from '../shared/urls/renderQueryString';
import replaceDataAndAttributes from '../shared/i18n/replaceDataAndAttributes';
import nmaExternalHash from '../shared/urls/nmaExternalHash';
import getErrorTranslations from '../shared/i18n/getErrorTranslations';
import showGeneralError from '../shared/utilities/showGeneralError';
import { PERSISTED_CLIENT_STATE_VALUES } from '../shared/data/persistedState';

function serverConfig(context, next) {
    const { urls } = window.bbcAccount.config;
    context.shared = assign({}, context.shared, { urls });

    next();
}

function serverLocals(context, next) {
    const peristedLocals = pick(
        window.bbcAccount.locals,
        PERSISTED_CLIENT_STATE_VALUES
    );
    context.shared = assign({}, context.shared, peristedLocals);

    next();
}

function templateFunctions(context, next) {
    context.shared.renderQueryString = renderQueryString;
    context.shared.replaceDataAndAttributes = replaceDataAndAttributes;
    context.shared.getErrorTranslations = getErrorTranslations;
    context.shared.nmaExternalHash = nmaExternalHash;
    context.shared.showGeneralError = showGeneralError;

    next();
}

export { serverConfig, serverLocals, templateFunctions };
